export default function PaymentInfo() {
    return (<div className="product__kv-info-cols show">
        <p className="product__kv-info-cols-link active f-exp">Оплата <i
            className="ico ico-arrow-bot-b"></i></p>
        <div className="product__kv-info-cols-list">
            <ul>
                <li><p><b>Картой онлайн</b>Оплата картами Visa, Mastercard, МИР, или картой
                    рассрочки “Халва”</p></li>
                <li><p><b>При получении</b>Возможна оплата курьеру при получении наличными или
                    картой</p></li>
                <li><p><b>Подели</b>Возможна оплата при помощи сервиса оплаты покупок по частям
                    “Подели”</p></li>
            </ul>
        </div>
    </div>)
}